export const hasDepartmentConfig = (configuration) =>
    !!(configuration && configuration.departamentos && configuration.departamentos.length > 0);



// WEBPACK FOOTER //
// ./src/functions/config.js